module.exports = __webpack_public_path__ + "static/media/header.58036a18.png";